
import { Card, CardBody, CardHeader, Col, FormGroup, Input, InputGroup, InputGroupText, Label, Row, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import DatePicker from "react-datepicker";
import './FT.css';
import { useNavigate } from "react-router-dom";

import { useEffect, useState } from "react";
import { Api } from "../../componentes/Api"
import * as moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import { CuadreAdmin } from "./Informes/CuadreAdmin";

    var Efectivo=0;
    var Credito=0;
    var Tarjeta=0;
    var Transferencia=0;
    var Cheque=0;
    var Total=0;
    var GTotal=0;
    var Capital=0;
    var Gastos=0;
const HistorialVenta = () => {
    const [fechaInicio, setFechaInicio] = useState(new Date());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [buscarPor, setBuscarPor] = useState("fecha")
    const [Listado, SetListado] = useState([]);

    const [ventas, setVentas] = useState([])
    const [Pventas, setPventas] = useState()
    const [Impresion, setImpresion] = useState(false);
    const [CuadreAdm, setCuadreAdm] = useState(false);
 const [R_API, setR_API] = useState("")

    const buscarVenta = async () => {
        let options = { year: 'numeric', month: '2-digit', day: '2-digit' };

        let _fechaInicio = fechaInicio.toLocaleDateString('es-PE', options)
        let _fechaFin = fechaFin.toLocaleDateString('es-PE', options)

        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");


      //  let response = await fetch(Api + `VentasTrans/HistorialFactura?buscarPor=${buscarPor}&fechaInicio=${_fechaInicio}&fechaFin=${_fechaFin}`)
        let response = await fetch(Api + "VentasTrans/HistorialFactura/" + buscarPor + "/" + fi + "/" + ff)
            .then((response) => {
                return response.ok ? response.json() : Promise.reject(response);
            })
            .then((dataJson) => {
                var data = dataJson;
                if (data.length >= 1) {
                    setVentas(data);
                    Credito = data.reduce((x, y) => {
                        return x + y.credito;
                    }, 0)
                    Efectivo = data.reduce((x, y) => {
                        return x + y.efectivo - y.devolucion;
                    }, 0)
                    Tarjeta = data.reduce((x, y) => {
                        return x + y.tarjeta;
                    }, 0)
                    Transferencia = data.reduce((x, y) => {
                        return x + y.transferencia;
                    }, 0)
                    Cheque = data.reduce((x, y) => {
                        return x + y.cheque;
                    }, 0)
                    Total = data.reduce((x, y) => {
                        return x + y.totalPago;
                    }, 0)

                    Listado.filter(x => data.some(o => o.facturaID === x.facturaID))

                    GTotal = Listado.reduce((x, y) => {
                        return x + y.ganancia;
                    }, 0)
                    Capital = Listado.reduce((x, y) => {
                        return x + y.capital;
                    }, 0)
                    Gastos = Listado.reduce((x, y) => {
                        return x + y.gastos;
                    }, 0)

                    setR_API(Api + "VentasTrans/HistorialFactura/" + buscarPor + "/" + fi + "/" + ff)
                } else { setVentas([]); }
            })}

    const navigate = useNavigate();
    const handleNavigate = () => {
        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");
        navigate("/ImpresionVentas/1", { state: { myData: Api + "VentasTrans/HistorialFactura/" + buscarPor + "/" + fi + "/" + ff } });
    };


    useEffect(() => {
        Efectivo = 0;
        Credito = 0;
        Tarjeta = 0;
        Transferencia = 0;
        Cheque = 0;
        Total = 0;
        setVentas([])
        obtenerDatos()
    }, [fechaInicio + fechaFin])

    const obtenerDatos = async () => {
        let fi = moment(fechaInicio).format("YYYY-MM-DD");
        let ff = moment(fechaFin).format("YYYY-MM-DD");

        let response = await fetch(Api + "VentasTrans/VerCuadreAdmin/" + fi + "/" + ff);
        if (response.ok) {
            let data1 = await response.json()
            SetListado(data1);
        }
    }
    const Cuadre = (d) => {
        setCuadreAdm(true)
        setPventas(d)

    }

    return (
        < >
            <div class="containerhv" >
                <h1 onClick={() =>setCuadreAdm(true)  }>Historial de ventas</h1>
                <div class="search-container">
                    <div class="date-input">
                        <label for="fecha-inicio">Fecha Inicio:</label>
                            <DatePicker 
                            className=" date"
                            selected={fechaInicio}
                            onChange={(date) => setFechaInicio(date)}
                            dateFormat='dd/MM/yyyy'
                        />
                    </div>
                    <div class="date-input">
                        <label for="fecha-fin">Fecha Fin:</label>
                        <DatePicker 
                            className="date"
                            selected={fechaFin}
                            onChange={(date) => setFechaFin(date)}
                            dateFormat='dd/MM/yyyy'
                        />
                    </div>
                
                    <button color="success" size="sm" class="btn-search"  block onClick={buscarVenta}>
                        <i className="fa fa-search" aria-hidden="true"></i> Buscar
                    </button>
                    <button size="sm" color="primary" class="btn-search" block onClick={()=>setImpresion(true)}>
                        <i class="fas fa-print"></i> Imprimir
                    </button>
                </div>
                <div class="summary">
                    <div class="summary-item">  Efectivo:<b>{Efectivo.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                    <div class="summary-item"> Credito:<b>{Credito.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b> </div>
                    <div class="summary-item">Tarjeta:<b> {Tarjeta.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                    <div class="summary-item">Transfe:<b>{Transferencia.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                    <div class="summary-item">  Cheque:<b>{Cheque.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                    <div class="summary-item">Total:<b>{Total.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                    <div class="summary-item">Ganancia:<b>{GTotal.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                    <div class="summary-item">Capital:<b>{Capital.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                    <div class="summary-item">Gastos:<b>{Gastos.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</b></div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>Fecha Registro</th>
                            <th>Numero Venta</th>
                            <th>Secuencia</th>
                            <th>Nombre Cliente</th>
                            <th>Pago</th>
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (ventas.length < 1) ? (
                                <tr>
                                    <td colSpan="7" style={{ textAlign: "center" }}>
                                        Sin resultados
                                    </td>
                                </tr>
                            ) : (

                                ventas.map((item) => (
                                    <tr key={item.facturaID}>
                                        <td>{moment(item.fecha).format("DD/MM/YYYY")}</td>

                                        <td>{item.facturaID}</td>
                                        <td>{item.ncf}</td>

                                        <td>{item.nombreCliente}</td>
                                        <td style={{ textTransform: "uppercase" }}>{item.formaPago1}</td>
                                        <td>{item.totalPago.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}</td>
                                        <td>
                                            <Button size="sm" color="info" outline
                                                onClick={() => Cuadre(item)}  >
                                                <i className="fa fa-edit" aria-hidden="true"></i> 
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )
                        }
                    </tbody>
                </table>
            </div>

            <Row>
               
            </Row>

            <Modal className="modal-preguntas" isOpen={CuadreAdm}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Cuadre Admin  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setCuadreAdm(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <CuadreAdmin data={Pventas }/>
                </ModalBody>

            </Modal>
            <Modal className="modal-preguntas" isOpen={Impresion}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> IMPRESION  </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setImpresion(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {<iframe
                                src={"/Informes/Facturacion/ListaFacturas.html?API=" + R_API}
                                title="Contenido HTML"
                                style={{ width: '100%', height: '1100px', border: 'none' }}

                            />}


                            <Button size="sm" color="danger"
                                onClick={() => setImpresion(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>
        </>
        )

}
export default HistorialVenta;